<template>
  <div class="header_box">
    <div class="containers">
      <Row class="header_top">
        <Col span="12" class="header_left">
          <img style="width:530px;margin-top:7px;" src="../../assets/images/logo.png" alt>
        </Col>
        <Col span="12" class="header_right">
          <!-- <span @click="modal1 = true">
            <Icon type="md-build"/>修改密码
          </span>
          <span class="pad10">|</span>-->
          <span @click="logout()">
            <Icon type="md-power" style="font-size:24px;"/> <span>安全退出</span>
          </span>
        </Col>
      </Row>
    </div>
    <div class="header_main"></div>
    <Modal v-model="modal1" width="350" title="修改密码" @on-ok="ok" @on-cancel="cancel">
      <Form ref="formInline" :model="formInline" :rules="ruleInline">
        <FormItem prop="oldpassword">
          <Input type="password" v-model="formInline.oldpassword" placeholder="请输入旧密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="newpassword">
          <Input type="password" v-model="formInline.newpassword" placeholder="请输入新密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="againpassword">
          <Input type="password" v-model="formInline.againpassword" placeholder="请重新输入新密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "headerbox",
  data() {
    return {
      modal1: false,
      formInline: {
        useoldpasswordr: "",
        newpassword: "",
        againpassword: ""
      },
      ruleInline: {
        oldpassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        newpassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          }
        ],
        againpassword: [
          {
            required: true,
            message: "请重新输入新密码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ok() {
      this.$Message.info("修改成功");
    },
    cancel() {
      this.$Message.info("修改失败");
    },
    logout() {
      this.$router.push({ name: "login" });
      this.$store.commit("logout");
    }
  }
};
</script>
<style scoped>
.header_box {
  height: 190px;
  width: 100%;
  background: #3e4c66;
}
.containers {
  width:99%;
  padding: 0px 0.5%;
  margin: auto;
}
.header_top {
  height: 50px;
  line-height: 50px;
  color: white;
  font-size: 14px;
}
.header_left {
  text-align: left;
  font-size: 20px;
}
.header_right {
  text-align: right;
}
.header_right span {
  cursor: pointer;
}
.header_main {
  width: 100%;
  height: 140px;
  background: url("../../assets/images/header_main.png");
  background-size: 100% 100%;
}
.pad10 {
  padding: 0px 10px;
}
.portrait {
  width: 100px;
  margin-left: 30px;
  padding-top: 60px;
}
.username {
  padding-top: 10px;
  color: white;
  font-size: 16px;
}


</style>





// WEBPACK FOOTER //
// src/components/header/headerbox.vue